module.exports = __webpack_public_path__ + "img/watch-3.eaf8eb5f.png";